module.exports = __webpack_public_path__ + "img/activities-5.2a3d658b.jpg";